import { useMutation } from '@tanstack/react-query';
import { apiManager } from "../api-manager";
import { apiClient } from '../api-manager-instance';
import { ENDPOINTS } from '../endpoints';

export const deleteSubscription = async (id: string) => {
  const res = await apiManager.delete(`/subscription-plan/admin/delete/${id}`);
  return res;
};


export const useDeleteSubscription = () =>
  useMutation({
    mutationFn: async (id: string) => {
      const res = await apiClient.delete(ENDPOINTS.SUBSCRIPTION_PLANS.DELETE_SUBSCRIPTION(id));
      return res.data;
    },
  });